/**
 * Builds a request processor.
 *
 * @typeParam TMeans - A type of initial request processing means.
 * @param config - Request processor configuration.
 *
 * @returns New request processor.
 */
export function requestProcessor(config) {
    const handler = config.handler.bind(config);
    return means => {
        const context = { ...means };
        context.next = nextHandlerCaller(config, context);
        return config.next(handler, context);
    };
}
/**
 * @internal
 */
function nextHandlerCaller(config, means) {
    return async (handler, modification) => {
        let context;
        if (modification) {
            context = { ...means, ...modification };
            context.next = nextHandlerCaller(config, context);
        }
        else {
            context = means;
        }
        return config.next(handler, context);
    };
}
//# sourceMappingURL=request-processor.js.map